import { StoreAction } from '../../types';
import { RESET_DATA_REDUX, SAVE_DATA_REDUX } from '../contants';

export default function saveData(state: any = {}, action: StoreAction) {
  switch (action.type) {
    case SAVE_DATA_REDUX: {
      if (!Array.isArray(action.payload) && typeof action.payload == 'object') {
        Object.keys(action.payload).forEach((key) => {
          action.payload[key] = {
            ...state[key],
            ...action.payload[key],
          };
        });
      }
      return { ...state, ...action.payload };
    }
    case RESET_DATA_REDUX: {
      if (typeof action.payload == 'object') {
        state[action.payload.key] = {};
      }
      return state;
    }
    default:
      return state;
  }
}
